import React, { useEffect } from "react";
import { Box, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes  } from "../../../../../../../redux/bourse/select_producer";


let useStyles = makeStyles((theme) => ({
    root: {
        width:"250px",
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box: {
        margin: 10,
        [theme.breakpoints.down("700")]: {
            margin: '10px 0px',
            width: '100%',
        },
    }
}))

export default function Index({handleChange , state}) {

    let classes = useStyles();
    let dispatch = useDispatch();

    const stateReducer = useSelector((state) => state.bourse_select_producer_reducer);


    const apiSubmit = () => {
        dispatch({
          type: actionTypes.selectProducerAsync,
          payload: {},
        });
      };

      useEffect(() => {
        apiSubmit();
      }, []);
      

    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                // marginBottom="30px"
                width="250px"
                height="40px"
            >
                <Autocomplete
                    size={"small"}
                    id="combo-box-demo"
                    // disabled={stateReducer.data ? false : true}
                    options={stateReducer?.data}
                    getOptionLabel={(option) => option.name}
                    value={state?.['producer'] ? state?.['producer'] : null}
                    onChange={(event, value) =>handleChange( value, "producer") }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="همه تولید کنندگان"
                            variant="outlined"
                        />
                    )}
                />
            </Box>
        </div>)
}
